
import React, { useState } from "react";
import Navbar from "../components/framepart/Navbar/Navbar";
import Sidebar from "../components/framepart/Sidebar/Sidebar";
import MainPanel from "../components/framepart/MainPanel/MainPanel";
import Footer from "../components/framepart/Footer/Footer";
import "../styles/main.css";
import * as PulseModules from "../pages/masterpages/pulse";

// ================================
// Constantes structurelles du layout
// ================================
const NAVBAR_HEIGHT = 45; // Hauteur fixe de la Navbar
const FOOTER_HEIGHT = 40; // Hauteur fixe du Footer

const LayoutPulse = ({ children }) => {
  const [ActiveComponent, setActiveComponent] = useState(() => PulseModules.Page41);
    
      console.log(ActiveComponent);
     // Module par défaut
  // ================================
  // Items du menu latéral (Sidebar)
  // ================================
  const sidebarItems = [
    { label: "Overview", icon: "/assets/menus/dashboard-alt.png", component: PulseModules.Page41 },
    { label: "Performance", icon: "/assets/menus/psychology.png", component: PulseModules.Page42  },
    { label: "Progress", icon: "/assets/menus/cube.png", component: PulseModules.Page43  },
    { label: "Alerts", icon: "/assets/menus/cog.png", component: PulseModules.Page44  },
    { label: "History", icon: "/assets/menus/cog.png", component: PulseModules.Page45  },
    { label: "Reports", icon: "/assets/menus/cube.png", component: PulseModules.Page46  },
  
  ];

  return (
    <div className="page-container" style={{ display: "flex", flexDirection: "column", height: "100vh", boxSizing: "border-box", overflow: "hidden", flexShrink: 0, }}>
      
      <div style={{ height: NAVBAR_HEIGHT, flexShrink: 0 }}>
        <Navbar logo={{ src: "/assets/logos/corelia.png", label: "Quantum Corelia" }} toolbar={<div style={{ display: "flex", gap: 6 }}>Outils</div>} />
      </div>

     
      <div className="Middle-container" style={{ display: "flex", height: `calc(100vh - ${NAVBAR_HEIGHT + FOOTER_HEIGHT}px)`, boxSizing: "border-box", minHeight: 0, overflowY: "none", flexShrink: 0, }}>
          
            <div className="Side-container" style={{ height: "100%", boxSizing: "border-box", backgroundColor: "transparent", flexShrink: 0, overflowY :"none", }}>
              <Sidebar items={sidebarItems} onItemClick={(component) => setActiveComponent(() => component)} style={{ height: "100%", boxSizing: "border-box", backgroundColor: "transparent", flexShrink: 0, overflowY :"none", }}>
              </Sidebar>
            </div>
        
           <div className="Center-container" style={{ height: "100%", flex: 1, minHeight: 0, overflowY: "auto", boxSizing: "border-box", flexShrink: 0, }}>
            <MainPanel style={{ height: "100%", flex: 1, minHeight: 0, overflowY: "auto", boxSizing: "border-box", flexShrink: 0, }}>
               {ActiveComponent && <ActiveComponent />}
            </MainPanel>
           </div>
      </div>

        <div style={{ height: FOOTER_HEIGHT, padding: 0, pargin: 0,}}>   
          <Footer />
        </div>
    </div>
  );
};

export default LayoutPulse;
